// SafeHarborGuidance — safe-harbor explanations (F9.1). Presentation.

export function SafeHarborGuidance() {
  return (
    <div>
      <h4 className="mb-2">Safe-Harbor Methods (IRC §409A)</h4>
      <ul className="stack-2">
        <li>
          <strong>Independent Appraisal:</strong> A valuation by a qualified independent appraiser
          creates a rebuttable presumption of reasonableness for 12 months.
        </li>
        <li>
          <strong>Illiquid Startup:</strong> For non-public companies under 10 years old, a
          formula-based FMV using a reasonable valuation method.
        </li>
        <li>
          <strong>Binding Formula:</strong> A formula determined in good faith and binding on all parties.
        </li>
        <li>
          <strong>None:</strong> No safe harbor is claimed — the burden of reasonableness remains on the
          company. Software output alone does not establish safe harbor.
        </li>
      </ul>
      <p className="field-hint mt-3">
        This tool produces calculation evidence to support, not replace, a qualified independent
        appraisal.
      </p>
    </div>
  );
}
